import React, { useState, useEffect } from "react";
import { userOrder } from '../../states/userOrder';
import { toast } from 'react-toastify';
import { apiGet } from '../../utils/api';
import { configShop } from '../../states/configShop';
import { FaStore, FaMapMarkerAlt, FaCheckCircle, FaArrowRight } from "react-icons/fa";

const ShopAdd = ({ setOpenModal }) => {
    const { dataConfig } = configShop();
    const { setDataUser } = userOrder();
    const [listaShops, setListaShops] = useState([]);
    const [shopSeleccionada, setShopSeleccionada] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cargando, setCargando] = useState(true);

    const brandColor = dataConfig?.page_menu?.button?.color      ?? "#6C63FF";
    const brandText  = dataConfig?.page_menu?.button?.color_text ?? "#ffffff";

    const obtenerShop = async () => {
        setCargando(true);
        try {
            const respuesta = await apiGet('/shops');
            setListaShops(respuesta.data);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => { obtenerShop(); }, []);

    const guardarInfo = async () => {
        if (!shopSeleccionada) {
            toast.error("Seleccione una tienda", { position: "top-center", autoClose: 4000 });
            return;
        }
        setLoading(true);
        setDataUser({
            popAddress: false,
            uuidShop: shopSeleccionada.uuid,
            shopData: shopSeleccionada,
            deliveryMethod: 2,
        });
        setOpenModal(false);
    };

    return (
        <div style={{ padding: "16px 20px", display: "flex", flexDirection: "column", gap: "12px" }}>

            {/* Descripción */}
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                background: `${brandColor}12`,
                borderRadius: "14px",
                padding: "14px",
            }}>
                <FaStore size={18} color={brandColor || "#6C63FF"} />
                <span style={{ fontSize: "13px", color: "#5C5C7A", lineHeight: 1.4 }}>
                    Elige la tienda más cercana para recoger tu pedido.
                </span>
            </div>

            {/* Lista de tiendas */}
            {cargando ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {[1, 2, 3].map((i) => (
                        <div key={i} style={{
                            height: "72px", borderRadius: "16px",
                            background: "linear-gradient(90deg, #F0F0F5 25%, #F8F8FC 50%, #F0F0F5 75%)",
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.4s infinite",
                        }} />
                    ))}
                </div>
            ) : listaShops.length === 0 ? (
                <div style={{ textAlign: "center", padding: "32px 0", color: "#AAAAB5", fontSize: "14px" }}>
                    No hay tiendas disponibles
                </div>
            ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {listaShops.map((shop) => {
                        const isSelected = shopSeleccionada?.uuid === shop.uuid;
                        return (
                            <button
                                key={shop.uuid}
                                onClick={() => setShopSeleccionada(shop)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "14px",
                                    width: "100%",
                                    padding: "14px 16px",
                                    background: isSelected ? `${brandColor}14` : "#F7F7FA",
                                    border: isSelected
                                        ? `2px solid ${brandColor || '#6C63FF'}`
                                        : "2px solid #EBEBF0",
                                    borderRadius: "16px",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    transition: "border-color 0.18s, background 0.18s, box-shadow 0.18s",
                                    boxShadow: isSelected
                                        ? `0 0 0 4px ${brandColor ? brandColor + "22" : "rgba(108,99,255,0.13)"}`
                                        : "none",
                                    boxSizing: "border-box",
                                }}
                            >
                                {/* Ícono */}
                                <div style={{
                                    width: "44px",
                                    height: "44px",
                                    borderRadius: "13px",
                                    background: isSelected ? `${brandColor}26` : "#EBEBF0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                    transition: "background 0.18s",
                                }}>
                                    <FaStore
                                        size={18}
                                        color={isSelected ? (brandColor || '#6C63FF') : "#AAAAB5"}
                                    />
                                </div>

                                {/* Info */}
                                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "3px" }}>
                                    <span style={{
                                        fontSize: "15px",
                                        fontWeight: "600",
                                        color: "#1A1A2E",
                                        lineHeight: 1.2,
                                    }}>
                                        {shop.name}
                                    </span>
                                    <span style={{
                                        fontSize: "12px",
                                        color: "#8888A0",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px",
                                    }}>
                                        <FaMapMarkerAlt size={10} />
                                        {shop.address}{shop.city ? `, ${shop.city}` : ""}
                                    </span>
                                </div>

                                {/* Check */}
                                {isSelected && (
                                    <FaCheckCircle
                                        size={20}
                                        color={brandColor || '#6C63FF'}
                                        style={{ flexShrink: 0 }}
                                    />
                                )}
                            </button>
                        );
                    })}
                </div>
            )}

            {/* Botón confirmar */}
            <button
                onClick={guardarInfo}
                disabled={!shopSeleccionada || loading}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    width: "100%",
                    height: "52px",
                    border: "none",
                    borderRadius: "14px",
                    background: brandColor || "#6C63FF",
                    color: brandText || "#FFFFFF",
                    fontSize: "16px",
                    fontWeight: "700",
                    cursor: !shopSeleccionada || loading ? "not-allowed" : "pointer",
                    opacity: !shopSeleccionada ? 0.45 : loading ? 0.7 : 1,
                    boxShadow: shopSeleccionada
                        ? `0 4px 16px ${brandColor ? brandColor + "55" : "rgba(108,99,255,0.3)"}`
                        : "none",
                    transition: "opacity 0.2s, box-shadow 0.2s",
                    marginTop: "4px",
                }}
            >
                {loading ? (
                    <span className="rg-btn-spinner" />
                ) : (
                    <>
                        <span>Seleccionar tienda</span>
                        <FaArrowRight size={14} />
                    </>
                )}
            </button>

            <style>{`
                @keyframes shimmer {
                    0%   { background-position: -200% 0; }
                    100% { background-position:  200% 0; }
                }
            `}</style>
        </div>
    );
};

export default ShopAdd;
